var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Generar ticket de ayuda",
        "hide-footer": "",
        centered: ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c(
        "div",
        [
          _c("label", { attrs: { for: "message" } }, [
            _vm._v("Cuéntanos en que podemos ayudarte")
          ]),
          _c("vs-textarea", {
            attrs: { id: "message", counter: "1000" },
            model: {
              value: _vm.messageTicket,
              callback: function($$v) {
                _vm.messageTicket = $$v
              },
              expression: "messageTicket"
            }
          })
        ],
        1
      ),
      _c(
        "vs-button",
        {
          staticClass: "m-top-20",
          staticStyle: { float: "right" },
          attrs: { color: "primary", type: "filled" },
          on: {
            click: function($event) {
              return _vm.sendTicketFile()
            }
          }
        },
        [_vm._v(" Enviar ticket ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }